import { GroupFS, RoundsFS, SubGroupFS } from "./fund-strategy-export-classes";

export const SUGGESTED_ROUNDS_NAMES = ['Seed', 'A round', 'B round', 'C round', 'D round', 'E round', 'F round', 'H round', 'I round',
  'J round' ];

export const FS_SUGGESTED_TOTAL_COMMITMENT = 100000000;
export const FS_SUGGESTED_EXPECTED_EXPENSES = 20000000;
export const FS_SUGGESTED_CARRY_PCNT = 0.2;

export const SUGGESTED_ROUNDS_DATA: RoundsFS[] = [
  {
    name: 'Pre-seed',
    roundOrder: 0,
    companiesNumber: null,
    esop: 5,
    preMoney: 4000000,
    round: 1000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'Seed',
    roundOrder: 1,
    companiesNumber: null,
    esop: 5,
    preMoney: 8000000,
    round: 2000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'A round',
    roundOrder: 2,
    companiesNumber: null,
    esop: 5,
    preMoney: 16000000,
    round: 4000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'B round',
    roundOrder: 3,
    companiesNumber: null,
    esop: 5,
    preMoney: 45000000,
    round: 5000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
  {
    name: 'C round',
    roundOrder: 4,
    companiesNumber: null,
    esop: 5,
    preMoney: 75000000,
    round: 15000000,
    investment: null,
    writeOff: null,
    exitCompNumber: null,
    exitCompPrice: null,
  },
];

export const SUGGESTED_GROUP_1_SUB_GROUPS: SubGroupFS[] = [
  {
    name: 'Group 1 (Success)',
    subGrOrder: 0,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'Group 1 (Moderate)',
    subGrOrder: 1,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'Group 1 (Write-off)',
    subGrOrder: 2,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
];

export const SUGGESTED_SUB_GROUPS: SubGroupFS[] = [
  {
    name: 'Success',
    subGrOrder: 0,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'x1',
    subGrOrder: 1,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
  {
    name: 'Write-off',
    subGrOrder: 2,
    roundsData: SUGGESTED_ROUNDS_DATA,
  },
];

export const SUGGESTED_GROUPS: GroupFS[] = [
  {
    name: 'Group 1',
    grOrder: 0,
    subGroups: SUGGESTED_GROUP_1_SUB_GROUPS,
  },
];
